import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";
import "regenerator-runtime/runtime";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(doJoinWaitlist),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(doUpdateLocation),
    _marked3 =
/*#__PURE__*/
regeneratorRuntime.mark(openLocationModal),
    _marked4 =
/*#__PURE__*/
regeneratorRuntime.mark(getMsa),
    _marked5 =
/*#__PURE__*/
regeneratorRuntime.mark(watchLocationForm),
    _marked6 =
/*#__PURE__*/
regeneratorRuntime.mark(watchWaitlistForm);

import { fetchEntityIfNeeded } from '@classpass/saga-tools';
import { all, call, fork, put, select, spawn, take, takeEvery } from 'redux-saga/effects';
import * as logger from 'universal-logger';
import { msas, glsLocation } from 'redux/saga/entities/bound';
import { geodetectMsa, errorActionCreator } from 'redux/saga/helpers';
import { msaByIdentifier } from 'redux/saga/selectors/msas';
import { deepExtract } from 'helpers/deep';
import { setMsaId, selectMsaId } from 'redux/modules/features/homepage';
import { showModal, hideModal, HIDE_MODAL } from 'redux/modules/modals';
import { ga } from 'helpers/multitrack';
import { addFailureNotification } from 'features/Banners/Banners.reducer';
import { doJoinWaitlist as leadgenJoinWaitlist } from 'features/LeadGenForm/LeadGenForm.saga';
import { persistUserLocation } from 'redux/saga/helpers/location';
import { selectUserLocation } from 'redux/modules/locale';
import { userErrorMessages as messages } from 'components/Errors/Error.messages';
var LOCATION_SELECTED = 'classpass/LocationModal/LOCATION_SELECTED';
var JOIN_WAITLIST = 'classpass/LocationModal/JOIN_WAITLIST';
var UPDATE_LOCATION = 'classpass/LocationModal/UPDATE_LOCATION';
export var joinWaitlist = function joinWaitlist() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      email = _ref.email;

  return {
    type: JOIN_WAITLIST,
    email: email
  };
};
export var locationSelected = function locationSelected(msaId) {
  return {
    type: LOCATION_SELECTED,
    msaId: msaId
  };
};
export var updateLocation = function updateLocation(location) {
  return {
    type: UPDATE_LOCATION,
    location: location
  };
};
export function doJoinWaitlist(client, _ref2) {
  var email, userLocation, lat, lon;
  return regeneratorRuntime.wrap(function doJoinWaitlist$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          email = _ref2.email;
          _context.next = 3;
          return spawn(ga, 'Geo_Detection_Modal', 'submit_email');

        case 3:
          _context.next = 5;
          return select(selectUserLocation);

        case 5:
          userLocation = _context.sent;

          if (!userLocation) {
            _context.next = 10;
            break;
          }

          lat = userLocation.lat, lon = userLocation.lon;
          _context.next = 10;
          return call(leadgenJoinWaitlist, client, {
            email: email,
            location: {
              lat: lat,
              lon: lon
            }
          });

        case 10:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}
export function doUpdateLocation(client, _ref3) {
  var _ref3$location, lat, lon, _ref4, _ref5, _ref5$, location, _ref6, msaId, isPurchasable;

  return regeneratorRuntime.wrap(function doUpdateLocation$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _ref3$location = _ref3.location, lat = _ref3$location.lat, lon = _ref3$location.lon;
          _context2.prev = 1;
          _context2.next = 4;
          return spawn(ga, 'Geo_Detection_Modal', 'submit_location');

        case 4:
          _context2.next = 6;
          return all([call(fetchEntityIfNeeded, glsLocation, [client, lat, lon]), call(persistUserLocation, lat, lon)]);

        case 6:
          _ref4 = _context2.sent;
          _ref5 = _slicedToArray(_ref4, 1);
          _ref5$ = _ref5[0];
          location = _ref5$ === void 0 ? {} : _ref5$;
          _ref6 = location.msa || {}, msaId = _ref6.id, isPurchasable = _ref6.package_purchase;

          if (!isPurchasable) {
            _context2.next = 16;
            break;
          }

          _context2.next = 14;
          return put(locationSelected(msaId));

        case 14:
          _context2.next = 16;
          return put(setMsaId(msaId));

        case 16:
          _context2.next = 22;
          break;

        case 18:
          _context2.prev = 18;
          _context2.t0 = _context2["catch"](1);
          _context2.next = 22;
          return all([call(logger.error, 'LocationModal: Could not change location using lat, lon', "".concat(lat, ", ").concat(lon), _context2.t0), put(addFailureNotification(messages.genericMessage))]);

        case 22:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, null, [[1, 18]]);
}
export function openLocationModal() {
  var modalProps,
      _ref7,
      msaId,
      _args3 = arguments;

  return regeneratorRuntime.wrap(function openLocationModal$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          modalProps = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};

          if (!__SERVER__) {
            _context3.next = 3;
            break;
          }

          return _context3.abrupt("return", -1);

        case 3:
          _context3.next = 5;
          return put(showModal('LocationModal', modalProps));

        case 5:
          _context3.next = 7;
          return take([HIDE_MODAL, locationSelected().type]);

        case 7:
          _ref7 = _context3.sent;
          msaId = _ref7.msaId;
          _context3.next = 11;
          return put(hideModal('LocationModal'));

        case 11:
          return _context3.abrupt("return", msaId);

        case 12:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}
export function getMsa(client) {
  var modalProps,
      options,
      _ref8,
      _ref9,
      allMsas,
      msa,
      savedMsaId,
      msaId,
      _args4 = arguments;

  return regeneratorRuntime.wrap(function getMsa$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          modalProps = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : {};
          options = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : {
            redirectBackOnMissing: true
          };
          _context4.prev = 2;
          _context4.next = 5;
          return all([// eslint-disable-line prefer-const
          call(fetchEntityIfNeeded, msas, [client]), call(geodetectMsa, client)]);

        case 5:
          _ref8 = _context4.sent;
          _ref9 = _slicedToArray(_ref8, 2);
          allMsas = _ref9[0];
          msa = _ref9[1];
          _context4.next = 11;
          return select(selectMsaId);

        case 11:
          savedMsaId = _context4.sent;

          if (!savedMsaId) {
            _context4.next = 14;
            break;
          }

          return _context4.abrupt("return", msaByIdentifier(allMsas, savedMsaId));

        case 14:
          if (!deepExtract('package_purchase', msa)) {
            _context4.next = 16;
            break;
          }

          return _context4.abrupt("return", msa);

        case 16:
          if (!__SERVER__) {
            _context4.next = 18;
            break;
          }

          return _context4.abrupt("return", -1);

        case 18:
          _context4.next = 20;
          return call(openLocationModal, modalProps);

        case 20:
          msaId = _context4.sent;
          msa = msaByIdentifier(allMsas, msaId);

          if (!deepExtract('package_purchase', msa)) {
            _context4.next = 27;
            break;
          }

          _context4.next = 25;
          return put(setMsaId(msa.id));

        case 25:
          _context4.next = 31;
          break;

        case 27:
          if (!(options.redirectBackOnMissing && window.history.length > 2)) {
            _context4.next = 31;
            break;
          }

          _context4.next = 30;
          return call([window.history, window.history.back]);

        case 30:
          return _context4.abrupt("return", -1);

        case 31:
          return _context4.abrupt("return", msa);

        case 34:
          _context4.prev = 34;
          _context4.t0 = _context4["catch"](2);
          _context4.next = 38;
          return put(errorActionCreator('GET_MSA_ERROR', _context4.t0));

        case 38:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4, null, [[2, 34]]);
}
export function watchLocationForm(client) {
  return regeneratorRuntime.wrap(function watchLocationForm$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return fork(takeEvery, updateLocation().type, doUpdateLocation, client);

        case 2:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5);
}
export function watchWaitlistForm(client) {
  return regeneratorRuntime.wrap(function watchWaitlistForm$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return fork(takeEvery, joinWaitlist().type, doJoinWaitlist, client);

        case 2:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6);
}